import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BounceLoader from "react-spinners/ClipLoader";
import useQueryParams from "../utils/query.params";
import {
  ERROR_ROUTE,
  SCREENER_ROUTE,
  START_ROUTE,
} from "../constants/routes.constants";
import RespondentFlowApi from "../services/respondentFlow.api";
import Error from "./Error";
import ClipLoader from "react-spinners/ClipLoader";
import { sessionStore } from "../services/storage.service";
import { windowLocation, windowLocationRelayed } from "../services/redirect.service";
import LoggerService from "../services/logger.service";

const Landing = () => {
  const [Loader] = useState(true);
  const [ErrorMessage, setErrorMessage] = useState("Loading");
  const [paramActive, setParamActive] = useState(false);

  const queryParams = useQueryParams(); // ✅ Hook called at the top
  const [params, setParams] = useState({});

  useEffect(() => {
    const temp = {};
    queryParams.forEach((value, key) => {
      temp[key] = value;
    });

    setParams(temp);

    if (Object.keys(temp).length > 0 && !paramActive) {
      setParamActive(true);
    }
  }, [queryParams]);

  let navigate = useNavigate();

  useEffect(() => {
    if (paramActive === true) {
      try {
        params["url"] = window.location.href;
        LoggerService.log(
          params.vq_tid,
          "",
          "Ending page going to call server endpoint /v1/ending",
          `${JSON.stringify(params)}`
        );
        RespondentFlowApi.post("/v1/ending", params)
          .then(async (data) => {
            if (data.result === "not_ok") {
              navigate(`${ERROR_ROUTE}?token=${params.vq_tid}`);
              return;
            } else if (data.hasError) {
              setErrorMessage(data.messages[0]);
              return;
            } else {
              debugger;
              if (data.isInternalRedirect) {
                let obj = {};
                obj.traceId = data.traceId;
                obj.paramList = data.paramList;
                obj.sessionUid = data.sessionUid;
                obj.surveyUid = data.surveyUid;
                obj.vendorUid = data.vendorUid;
                obj.vendorToken = data.vendorToken ?? "";
                obj.token = data.token;
                obj.tokenId = data.tokenId;
                obj.userUid = data.userUid;
                obj.userId = data.userId;
                obj.isEnding = true;
                obj.rdEnable = data.rdEnable ?? false;
                sessionStore.clear();
                sessionStore.setItem("params", JSON.stringify(obj));

                navigate(`${START_ROUTE}?token=${obj.token}`);
              } else {
                sessionStore.clear();
                //TODO:: redirect via
                windowLocationRelayed(data.redirectUrl,params.vq_tid);
                //window.location.href = `${data.redirectUrl}`;
              }
            }
          })
          .catch((e) => {
            console.error(e);
            navigate(ERROR_ROUTE);
          });
      } catch (err) {
        console.error(err);
        throw err;
      }
    }
    // eslint-disable-next-line
  }, [paramActive]);

  return (
    <>
      {Loader ? (
        ErrorMessage === "Loading" ? (
          <div className="flex flex-col items-center justify-center h-screen bg-gray-200">
            <ClipLoader color="#f00" loading={true} size={80} />
          </div>
        ) : (
          <Error ErrorMessage={ErrorMessage} />
        )
      ) : (
        <>
          <div className="flex  justify-center">
            <img
              src="https://img.icons8.com/bubbles/256/man-with-a-clock.png"
              alt=""
            />
          </div>
        </>
      )}
    </>
  );
};

export default Landing;
